import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { useRootContext, setRsvpContext } from '../partials/context/rootContext';
import Greeting from '../partials/blocks/greeting';
import RoundedContainer from '../partials/components/roundedContainer';
import ScheduleListItem from '../partials/components/scheduleListItem';
import ScheduleList from '../partials/components/scheduleList';
import CTAButton from '../partials/components/ctaButton';
import DividerLine from '../partials/components/dividerLine';
import RoomTimeSelection from '../partials/components/roomTimeSelection';

import wpStyles from '../wordpressStyles';


const AfterEvent = ({ ...props }) => {
    const { rsvpContext, setRsvpContext, scheduleContext } = useRootContext();
   
    return (
        <div className="px-4 font-sans container">
            <Greeting 
                firstName={props.data.attendee.first_name}
                location={props.data.event.location_below_greeting ? props.data.attendee.location : 'Non-Regional'}
            />
            <div className="prose" dangerouslySetInnerHTML={{__html: props.data.event.post_event_message}}></div>
        </div>
    );
};

export default AfterEvent;
